"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[990],{

/***/ 2217:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _heroicons_react_20_solid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4589);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);




const Input = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)((param, ref)=>{
    let { error , id , isDirty , label , ...inputProps } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "relative group",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                htmlFor: id,
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("absolute -top-2.5 left-6 h-4 inline-block bg-white px-1 text-11 leading-140 font-bold uppercase", {
                    "text-blue-800": !error
                }, {
                    "text-error": error
                }),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "hidden group-focus-within:block absolute bottom-0 left-0 bg-iceblue-100 w-full h-1.5 z-0"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "relative z-1",
                        children: label
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                id: id,
                ref: ref,
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("w-full text-15 leading-140 tracking-3 text-blue-800 border outline-none rounded-xl md:rounded-3xl pl-7 pr-16 py-4", {
                    "border-blue-400 focus:bg-iceblue-100 focus:border-blue-400 focus:ring-blue-400": !error
                }, {
                    "border-error focus:border-error focus:ring-error": error
                }),
                ...inputProps
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_20_solid__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("absolute top-4 transition-opacity delay-300 right-6 w-6 h-6", {
                    "opacity-0": !isDirty || error
                }, {
                    "opacity-100": isDirty && !error
                })
            }),
            error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-error text-11 px-7 pt-1 font-medium",
                children: error
            })
        ]
    });
});
Input.displayName = "Input";
/* harmony default export */ __webpack_exports__["Z"] = (Input);


/***/ }),

/***/ 2990:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ WhistleblowerFormSection; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./lib/types/index.ts
var types = __webpack_require__(608);
// EXTERNAL MODULE: ./components/container.tsx
var container = __webpack_require__(2606);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(7536);
// EXTERNAL MODULE: ./components/input.tsx
var input = __webpack_require__(2217);
// EXTERNAL MODULE: ./components/select.tsx
var components_select = __webpack_require__(4963);
// EXTERNAL MODULE: ./components/submit-button.tsx
var submit_button = __webpack_require__(809);
// EXTERNAL MODULE: ./components/textarea.tsx
var components_textarea = __webpack_require__(5049);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/zod/lib/index.mjs
var lib = __webpack_require__(1604);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/zod/dist/zod.mjs + 1 modules
var zod = __webpack_require__(6312);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/render.js
var render = __webpack_require__(2351);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-id.js
var use_id = __webpack_require__(9946);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/match.js
var match = __webpack_require__(2984);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-iso-morphic-effect.js
var use_iso_morphic_effect = __webpack_require__(6723);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/keyboard.js
var keyboard = __webpack_require__(1363);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/focus-management.js
var focus_management = __webpack_require__(4575);
;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/hooks/use-flags.js
function use_flags_b(g=0){let[r,l]=(0,react.useState)(g),u=(0,react.useCallback)(e=>l(a=>a|e),[r]),n=(0,react.useCallback)(e=>Boolean(r&e),[r]),o=(0,react.useCallback)(e=>l(a=>a&~e),[l]),s=(0,react.useCallback)(e=>l(a=>a^e),[l]);return{addFlag:u,hasFlag:n,removeFlag:o,toggleFlag:s}}

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-sync-refs.js
var use_sync_refs = __webpack_require__(3784);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-event.js
var use_event = __webpack_require__(3781);
;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/components/label/label.js
let u=(0,react.createContext)(null);function c(){let n=(0,react.useContext)(u);if(n===null){let r=new Error("You used a <Label /> component, but it is not inside a relevant parent.");throw Error.captureStackTrace&&Error.captureStackTrace(r,c),r}return n}function label_M(){let[n,r]=(0,react.useState)([]);return[n.length>0?n.join(" "):void 0,(0,react.useMemo)(()=>function(e){let o=(0,use_event/* useEvent */.z)(l=>(r(t=>[...t,l]),()=>r(t=>{let i=t.slice(),a=i.indexOf(l);return a!==-1&&i.splice(a,1),i}))),s=(0,react.useMemo)(()=>({register:o,slot:e.slot,name:e.name,props:e.props}),[o,e.slot,e.name,e.props]);return react.createElement(u.Provider,{value:s},e.children)},[r])]}let h="label",F=(0,render/* forwardRefWithAs */.yV)(function(r,d){let e=(0,use_id/* useId */.M)(),{id:o=`headlessui-label-${e}`,passive:s=!1,...l}=r,t=c(),i=(0,use_sync_refs/* useSyncRefs */.T)(d);(0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>t.register(o),[o,t.register]);let a={ref:i,...t.props,id:o};return s&&("onClick"in a&&delete a.onClick,"onClick"in l&&delete l.onClick),(0,render/* render */.sY)({ourProps:a,theirProps:l,slot:t.slot||{},defaultTag:h,name:t.name||"Label"})});

;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/components/description/description.js
let d=(0,react.createContext)(null);function description_u(){let n=(0,react.useContext)(d);if(n===null){let t=new Error("You used a <Description /> component, but it is not inside a relevant parent.");throw Error.captureStackTrace&&Error.captureStackTrace(t,description_u),t}return n}function description_k(){let[n,t]=(0,react.useState)([]);return[n.length>0?n.join(" "):void 0,(0,react.useMemo)(()=>function(e){let i=(0,use_event/* useEvent */.z)(r=>(t(o=>[...o,r]),()=>t(o=>{let s=o.slice(),p=s.indexOf(r);return p!==-1&&s.splice(p,1),s}))),a=(0,react.useMemo)(()=>({register:i,slot:e.slot,name:e.name,props:e.props}),[i,e.slot,e.name,e.props]);return react.createElement(d.Provider,{value:a},e.children)},[t])]}let S="p",description_F=(0,render/* forwardRefWithAs */.yV)(function(t,c){let e=(0,use_id/* useId */.M)(),{id:i=`headlessui-description-${e}`,...a}=t,r=description_u(),o=(0,use_sync_refs/* useSyncRefs */.T)(c);(0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>r.register(i),[i,r.register]);let s={ref:o,...r.props,id:i};return (0,render/* render */.sY)({ourProps:s,theirProps:a,slot:r.slot||{},defaultTag:S,name:r.name||"Description"})});

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/owner.js
var owner = __webpack_require__(5466);
;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/hooks/use-tree-walker.js
function use_tree_walker_F({container:e,accept:t,walk:r,enabled:c=!0}){let o=(0,react.useRef)(t),l=(0,react.useRef)(r);(0,react.useEffect)(()=>{o.current=t,l.current=r},[t,r]),(0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>{if(!e||!c)return;let n=(0,owner/* getOwnerDocument */.r)(e);if(!n)return;let f=o.current,p=l.current,d=Object.assign(i=>f(i),{acceptNode:f}),u=n.createTreeWalker(e,NodeFilter.SHOW_ELEMENT,d,!1);for(;u.nextNode();)p(u.currentNode)},[e,c,o,l])}

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/internal/hidden.js
var internal_hidden = __webpack_require__(6045);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/form.js
var utils_form = __webpack_require__(8689);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-controllable.js
var use_controllable = __webpack_require__(1147);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/bugs.js
var bugs = __webpack_require__(4103);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-latest-value.js
var use_latest_value = __webpack_require__(3855);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-disposables.js
var use_disposables = __webpack_require__(4192);
;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/components/radio-group/radio-group.js
var he=(t=>(t[t.RegisterOption=0]="RegisterOption",t[t.UnregisterOption=1]="UnregisterOption",t))(he||{});let ke={[0](n,r){let t=[...n.options,{id:r.id,element:r.element,propsRef:r.propsRef}];return{...n,options:(0,focus_management/* sortByDomNode */.z2)(t,d=>d.element.current)}},[1](n,r){let t=n.options.slice(),d=n.options.findIndex(c=>c.id===r.id);return d===-1?n:(t.splice(d,1),{...n,options:t})}},$=(0,react.createContext)(null);$.displayName="RadioGroupDataContext";function ne(n){let r=(0,react.useContext)($);if(r===null){let t=new Error(`<${n} /> is missing a parent <RadioGroup /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(t,ne),t}return r}let V=(0,react.createContext)(null);V.displayName="RadioGroupActionsContext";function ie(n){let r=(0,react.useContext)(V);if(r===null){let t=new Error(`<${n} /> is missing a parent <RadioGroup /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(t,ie),t}return r}function Fe(n,r){return (0,match/* match */.E)(r.type,ke,n,r)}let Le="div",Ce=(0,render/* forwardRefWithAs */.yV)(function(r,t){let d=(0,use_id/* useId */.M)(),{id:c=`headlessui-radiogroup-${d}`,value:D,defaultValue:O,name:I,onChange:E,by:G=(e,i)=>e===i,disabled:h=!1,...U}=r,T=(0,use_event/* useEvent */.z)(typeof G=="string"?(e,i)=>{let o=G;return(e==null?void 0:e[o])===(i==null?void 0:i[o])}:G),[k,F]=(0,react.useReducer)(Fe,{options:[]}),a=k.options,[M,N]=label_M(),[m,L]=description_k(),C=(0,react.useRef)(null),W=(0,use_sync_refs/* useSyncRefs */.T)(C,t),[l,x]=(0,use_controllable/* useControllable */.q)(D,E,O),s=(0,react.useMemo)(()=>a.find(e=>!e.propsRef.current.disabled),[a]),b=(0,react.useMemo)(()=>a.some(e=>T(e.propsRef.current.value,l)),[a,l]),u=(0,use_event/* useEvent */.z)(e=>{var o;if(h||T(e,l))return!1;let i=(o=a.find(f=>T(f.propsRef.current.value,e)))==null?void 0:o.propsRef.current;return i!=null&&i.disabled?!1:(x==null||x(e),!0)});use_tree_walker_F({container:C.current,accept(e){return e.getAttribute("role")==="radio"?NodeFilter.FILTER_REJECT:e.hasAttribute("role")?NodeFilter.FILTER_SKIP:NodeFilter.FILTER_ACCEPT},walk(e){e.setAttribute("role","none")}});let K=(0,use_event/* useEvent */.z)(e=>{let i=C.current;if(!i)return;let o=(0,owner/* getOwnerDocument */.r)(i),f=a.filter(p=>p.propsRef.current.disabled===!1).map(p=>p.element.current);switch(e.key){case keyboard/* Keys.Enter */.R.Enter:(0,utils_form/* attemptSubmit */.g)(e.currentTarget);break;case keyboard/* Keys.ArrowLeft */.R.ArrowLeft:case keyboard/* Keys.ArrowUp */.R.ArrowUp:if(e.preventDefault(),e.stopPropagation(),(0,focus_management/* focusIn */.jA)(f,focus_management/* Focus.Previous */.TO.Previous|focus_management/* Focus.WrapAround */.TO.WrapAround)===focus_management/* FocusResult.Success */.fE.Success){let y=a.find(j=>j.element.current===(o==null?void 0:o.activeElement));y&&u(y.propsRef.current.value)}break;case keyboard/* Keys.ArrowRight */.R.ArrowRight:case keyboard/* Keys.ArrowDown */.R.ArrowDown:if(e.preventDefault(),e.stopPropagation(),(0,focus_management/* focusIn */.jA)(f,focus_management/* Focus.Next */.TO.Next|focus_management/* Focus.WrapAround */.TO.WrapAround)===focus_management/* FocusResult.Success */.fE.Success){let y=a.find(j=>j.element.current===(o==null?void 0:o.activeElement));y&&u(y.propsRef.current.value)}break;case keyboard/* Keys.Space */.R.Space:{e.preventDefault(),e.stopPropagation();let p=a.find(y=>y.element.current===(o==null?void 0:o.activeElement));p&&u(p.propsRef.current.value)}break}}),w=(0,use_event/* useEvent */.z)(e=>(F({type:0,...e}),()=>F({type:1,id:e.id}))),R=(0,react.useMemo)(()=>({value:l,firstOption:s,containsCheckedOption:b,disabled:h,compare:T,...k}),[l,s,b,h,T,k]),S=(0,react.useMemo)(()=>({registerOption:w,change:u}),[w,u]),ae={ref:W,id:c,role:"radiogroup","aria-labelledby":M,"aria-describedby":m,onKeyDown:K},le=(0,react.useMemo)(()=>({value:l}),[l]),_=(0,react.useRef)(null),pe=(0,use_disposables/* useDisposables */.G)();return (0,react.useEffect)(()=>{!_.current||O!==void 0&&pe.addEventListener(_.current,"reset",()=>{u(O)})},[_,u]),react.createElement(L,{name:"RadioGroup.Description"},react.createElement(N,{name:"RadioGroup.Label"},react.createElement(V.Provider,{value:S},react.createElement($.Provider,{value:R},I!=null&&l!=null&&(0,utils_form/* objectToFormEntries */.t)({[I]:l}).map(([e,i],o)=>react.createElement(internal_hidden/* Hidden */._,{features:internal_hidden/* Features.Hidden */.A.Hidden,ref:o===0?f=>{var p;_.current=(p=f==null?void 0:f.closest("form"))!=null?p:null}:void 0,...(0,render/* compact */.oA)({key:e,as:"input",type:"radio",checked:i!=null,hidden:!0,readOnly:!0,name:e,value:i})})),(0,render/* render */.sY)({ourProps:ae,theirProps:U,slot:le,defaultTag:Le,name:"RadioGroup"})))))});var xe=(t=>(t[t.Empty=1]="Empty",t[t.Active=2]="Active",t))(xe||{});let we="div",Ie=(0,render/* forwardRefWithAs */.yV)(function(r,t){var w;let d=(0,use_id/* useId */.M)(),{id:c=`headlessui-radiogroup-option-${d}`,value:D,disabled:O=!1,...I}=r,E=(0,react.useRef)(null),G=(0,use_sync_refs/* useSyncRefs */.T)(E,t),[h,U]=label_M(),[T,k]=description_k(),{addFlag:F,removeFlag:a,hasFlag:M}=use_flags_b(1),N=(0,use_latest_value/* useLatestValue */.E)({value:D,disabled:O}),m=ne("RadioGroup.Option"),L=ie("RadioGroup.Option");(0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>L.registerOption({id:c,element:E,propsRef:N}),[c,L,E,r]);let C=(0,use_event/* useEvent */.z)(R=>{var S;if((0,bugs/* isDisabledReactIssue7711 */.P)(R.currentTarget))return R.preventDefault();!L.change(D)||(F(2),(S=E.current)==null||S.focus())}),W=(0,use_event/* useEvent */.z)(R=>{if((0,bugs/* isDisabledReactIssue7711 */.P)(R.currentTarget))return R.preventDefault();F(2)}),l=(0,use_event/* useEvent */.z)(()=>a(2)),x=((w=m.firstOption)==null?void 0:w.id)===c,s=m.disabled||O,b=m.compare(m.value,D),u={ref:G,id:c,role:"radio","aria-checked":b?"true":"false","aria-labelledby":h,"aria-describedby":T,"aria-disabled":s?!0:void 0,tabIndex:(()=>s?-1:b||!m.containsCheckedOption&&x?0:-1)(),onClick:s?void 0:C,onFocus:s?void 0:W,onBlur:s?void 0:l},K=(0,react.useMemo)(()=>({checked:b,disabled:s,active:M(2)}),[b,s,M]);return react.createElement(k,{name:"RadioGroup.Description"},react.createElement(U,{name:"RadioGroup.Label"},(0,render/* render */.sY)({ourProps:u,theirProps:I,slot:K,defaultTag:we,name:"RadioGroup.Option"})))}),ut=Object.assign(Ce,{Option:Ie,Label:F,Description:description_F});

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./components/radio-group.tsx




const ReadioGroup = /*#__PURE__*/ (0,react.forwardRef)((param, ref)=>{
    let { error , id , isDirty , label , onChange , options , value  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative group",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                htmlFor: id,
                className: classnames_default()("block mb-2 text-15 leading-140 text-blue-800", {
                    "text-blue-800": !error
                }, {
                    "text-error": error
                }),
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ut, {
                className: "flex items-center gap-4",
                id: id,
                ref: ref,
                onChange: onChange,
                value: value,
                children: options.map((option)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ut.Option, {
                                value: option.toLowerCase(),
                                className: "group flex size-5 items-center justify-center rounded-full border bg-white",
                                children: (param)=>{
                                    let { checked  } = param;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: classnames_default()("size-3 rounded-full", {
                                            invisible: !checked,
                                            visible: checked
                                        }, {
                                            "bg-blue-800": !error
                                        }, {
                                            "bg-error": error
                                        })
                                    });
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ut.Label, {
                                className: "text-11 uppercase font-bold",
                                children: option
                            })
                        ]
                    }, option))
            }),
            error && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-error text-11 px-7 pt-1 font-medium",
                children: error
            })
        ]
    });
});
ReadioGroup.displayName = "RadioGroup";
/* harmony default export */ var radio_group = (ReadioGroup);

;// CONCATENATED MODULE: ./components/sections/whistleblower-form.tsx












const formSchema = lib.z.object({
    currentEmployee: lib.z.literal("yes").or(lib.z.literal("no")).optional(),
    relationshipToDistalmotion: lib.z.string().optional(),
    involvedIndividuals: lib.z.string().min(1, "Required"),
    incidentTime: lib.z.string(),
    moreThanOnce: lib.z.literal("yes").or(lib.z.literal("no")).optional(),
    typeOfIncident: lib.z.string().min(1, "Required"),
    incidentDescription: lib.z.string().min(1, "Required"),
    managementInvolved: lib.z.literal("yes").or(lib.z.literal("no")).optional(),
    reportedInternally: lib.z.literal("yes").or(lib.z.literal("no")).optional(),
    reportedExternally: lib.z.literal("yes").or(lib.z.literal("no")).optional(),
    witnesses: lib.z.literal("yes").or(lib.z.literal("no")).optional(),
    namesOfWitnesses: lib.z.string().optional(),
    filesAvailable: lib.z.literal("yes").or(lib.z.literal("no")).optional(),
    files: lib.z.custom((value)=>value instanceof FileList && value.length > 0, {
        message: "Please upload at least one file"
    }).optional().refine((files)=>Array.from(files !== null && files !== void 0 ? files : []).every((file)=>file.size <= 5 * 1024 * 1024), {
        message: "Each file must be less than 5MB"
    }),
    willingToAssist: lib.z.literal("yes").or(lib.z.literal("no")).optional(),
    email: lib.z.union([
        lib.z.literal(""),
        lib.z.string().email("Invalid email")
    ])
});
function WhistleblowerFormSection(param) {
    let { data: { title , paragraph , notice , to  } , settings  } = param;
    var _errors_relationshipToDistalmotion, _errors_involvedIndividuals, _errors_incidentTime, _errors_incidentDescription, _errors_namesOfWitnesses, _errors_email, _settings_texts;
    const successMsg = "Report successfully sent!";
    const errorMsg = "Report could not be sent. Please try again later.";
    const fileInputRef = (0,react.useRef)(null);
    const [submitState, setSubmitState] = (0,react.useState)("initial");
    const { control , formState: { dirtyFields , errors , isSubmitting  } , handleSubmit , register , reset  } = (0,index_esm/* useForm */.cI)({
        defaultValues: {
            currentEmployee: undefined,
            relationshipToDistalmotion: "",
            involvedIndividuals: "",
            incidentTime: "",
            moreThanOnce: undefined,
            typeOfIncident: "",
            incidentDescription: "",
            managementInvolved: undefined,
            reportedInternally: undefined,
            reportedExternally: undefined,
            witnesses: undefined,
            namesOfWitnesses: "",
            filesAvailable: undefined,
            files: undefined,
            willingToAssist: undefined,
            email: ""
        },
        mode: "onChange",
        resolver: (0,zod/* zodResolver */.F)(formSchema)
    });
    const handleClick = ()=>{
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };
    const onSubmit = async (data)=>{
        const formData = new FormData();
        var _data_currentEmployee;
        formData.append("currentEmployee", (_data_currentEmployee = data.currentEmployee) !== null && _data_currentEmployee !== void 0 ? _data_currentEmployee : "Not provided");
        formData.append("involvedIndividuals", data.involvedIndividuals);
        var _data_incidentTime;
        formData.append("incidentTime", (_data_incidentTime = data.incidentTime) !== null && _data_incidentTime !== void 0 ? _data_incidentTime : "Not provided");
        var _data_moreThanOnce;
        formData.append("moreThanOnce", (_data_moreThanOnce = data.moreThanOnce) !== null && _data_moreThanOnce !== void 0 ? _data_moreThanOnce : "Not provided");
        formData.append("typeOfIncident", data.typeOfIncident);
        formData.append("incidentDescription", data.incidentDescription);
        var _data_managementInvolved;
        formData.append("managementInvolved", (_data_managementInvolved = data.managementInvolved) !== null && _data_managementInvolved !== void 0 ? _data_managementInvolved : "Not provided");
        var _data_reportedInternally;
        formData.append("reportedInternally", (_data_reportedInternally = data.reportedInternally) !== null && _data_reportedInternally !== void 0 ? _data_reportedInternally : "Not provided");
        var _data_reportedExternally;
        formData.append("reportedExternally", (_data_reportedExternally = data.reportedExternally) !== null && _data_reportedExternally !== void 0 ? _data_reportedExternally : "Not provided");
        var _data_witnesses;
        formData.append("witnesses", (_data_witnesses = data.witnesses) !== null && _data_witnesses !== void 0 ? _data_witnesses : "Not provided");
        var _data_namesOfWitnesses;
        formData.append("namesOfWitnesses", (_data_namesOfWitnesses = data.namesOfWitnesses) !== null && _data_namesOfWitnesses !== void 0 ? _data_namesOfWitnesses : "Not provided");
        var _data_filesAvailable;
        formData.append("filesAvailable", (_data_filesAvailable = data.filesAvailable) !== null && _data_filesAvailable !== void 0 ? _data_filesAvailable : "Not provided");
        var _data_willingToAssist;
        formData.append("willingToAssist", (_data_willingToAssist = data.willingToAssist) !== null && _data_willingToAssist !== void 0 ? _data_willingToAssist : "Not provided");
        var _data_email;
        formData.append("email", (_data_email = data.email) !== null && _data_email !== void 0 ? _data_email : "Not provided");
        formData.append("to", to);
        var _data_files;
        for(let i = 0; i < ((_data_files = data.files) !== null && _data_files !== void 0 ? _data_files : []).length; i++){
            if (data.files) {
                formData.append("files", data.files[i]);
            }
        }
        const response = await fetch("/api/send-email", {
            method: "POST",
            body: formData
        });
        if (response.ok) {
            reset();
            return setSubmitState("success");
        }
        setSubmitState("error");
    };
    var _field_value, _settings_texts_valueContactSend;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* default */.Z, {
        size: types/* ContainerSize.wide */.B.wide,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "grid grid-cols-12 gap-1.5 md:gap-6 relative",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "col-start-2 col-span-10 md:col-start-4 md:col-span-6 space-y-10",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "text-32 md:text-35 leading-130 font-bold text-blue-800",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "prose",
                            dangerouslySetInnerHTML: {
                                __html: paragraph
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                            className: "space-y-8",
                            onSubmit: handleSubmit(onSubmit),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                                    control: control,
                                    name: "currentEmployee",
                                    render: (param)=>{
                                        let { field  } = param;
                                        var _errors_currentEmployee;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(radio_group, {
                                            options: [
                                                "Yes",
                                                "No"
                                            ],
                                            label: "Are you a current employee of Distalmotion?",
                                            error: (_errors_currentEmployee = errors["currentEmployee"]) === null || _errors_currentEmployee === void 0 ? void 0 : _errors_currentEmployee.message,
                                            id: "currentEmployee",
                                            isDirty: dirtyFields["currentEmployee"],
                                            onChange: field.onChange,
                                            value: field.value
                                        });
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_textarea/* default */.Z, {
                                    error: (_errors_relationshipToDistalmotion = errors["relationshipToDistalmotion"]) === null || _errors_relationshipToDistalmotion === void 0 ? void 0 : _errors_relationshipToDistalmotion.message,
                                    label: "If No, what is your relationship to Distalmotion?",
                                    id: "relationshipToDistalmotion",
                                    isDirty: dirtyFields["relationshipToDistalmotion"],
                                    ...register("relationshipToDistalmotion")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_textarea/* default */.Z, {
                                    error: (_errors_involvedIndividuals = errors["involvedIndividuals"]) === null || _errors_involvedIndividuals === void 0 ? void 0 : _errors_involvedIndividuals.message,
                                    label: "Who are the individuals involved in the incident? (Required)",
                                    id: "involvedIndividuals",
                                    isDirty: dirtyFields["involvedIndividuals"],
                                    ...register("involvedIndividuals")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_textarea/* default */.Z, {
                                    error: (_errors_incidentTime = errors["incidentTime"]) === null || _errors_incidentTime === void 0 ? void 0 : _errors_incidentTime.message,
                                    label: "When did the incident occur?",
                                    id: "incidentTime",
                                    isDirty: dirtyFields["incidentTime"],
                                    ...register("incidentTime")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                                    control: control,
                                    name: "moreThanOnce",
                                    render: (param)=>{
                                        let { field  } = param;
                                        var _errors_moreThanOnce;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(radio_group, {
                                            options: [
                                                "Yes",
                                                "No"
                                            ],
                                            label: "Did the incident occur more than once?",
                                            error: (_errors_moreThanOnce = errors["moreThanOnce"]) === null || _errors_moreThanOnce === void 0 ? void 0 : _errors_moreThanOnce.message,
                                            id: "moreThanOnce",
                                            isDirty: dirtyFields["moreThanOnce"],
                                            onChange: field.onChange,
                                            value: field.value
                                        });
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                                    render: (param)=>{
                                        let { field  } = param;
                                        var _errors_typeOfIncident;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_select/* default */.Z, {
                                            error: (_errors_typeOfIncident = errors["typeOfIncident"]) === null || _errors_typeOfIncident === void 0 ? void 0 : _errors_typeOfIncident.message,
                                            id: "typeOfIncident",
                                            label: "What type of incident would you like to report? (Required). Refer to the Notice for description.",
                                            options: [
                                                "Accounting, Auditing, and Internal financial controls",
                                                "Anti-Trust",
                                                "Bribery and Corruption",
                                                "Compliance and Regulation Violation",
                                                "Conflict of Interest",
                                                "Discrimination",
                                                "Fraud",
                                                "Falsification of Records",
                                                "Harassment",
                                                "HIPPA",
                                                "Hostile Work Environment",
                                                "Improper giving and receiving gifts",
                                                "IT Security",
                                                "Data Breach",
                                                "Retaliation",
                                                "Safety Concerns",
                                                "Sexual Harassment",
                                                "Others"
                                            ],
                                            selected: field.value,
                                            onChange: field.onChange
                                        });
                                    },
                                    control: control,
                                    name: "typeOfIncident"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_textarea/* default */.Z, {
                                            error: (_errors_incidentDescription = errors["incidentDescription"]) === null || _errors_incidentDescription === void 0 ? void 0 : _errors_incidentDescription.message,
                                            label: "What would you like to report? (Required)",
                                            id: "incidentDescription",
                                            isDirty: dirtyFields["incidentDescription"],
                                            ...register("incidentDescription"),
                                            className: "h-40"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-11",
                                            children: "Please provide all details regarding the alleged incident, including any information that could be valuable in the evaluation of this situation, but exercise care to not provide details that may reveal your identity unless you wish to do so."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                                    control: control,
                                    name: "managementInvolved",
                                    render: (param)=>{
                                        let { field  } = param;
                                        var _errors_managementInvolved;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(radio_group, {
                                            options: [
                                                "Yes",
                                                "No"
                                            ],
                                            label: "Was someone from the management involved in the incident?",
                                            error: (_errors_managementInvolved = errors["managementInvolved"]) === null || _errors_managementInvolved === void 0 ? void 0 : _errors_managementInvolved.message,
                                            id: "managementInvolved",
                                            isDirty: dirtyFields["managementInvolved"],
                                            onChange: field.onChange,
                                            value: field.value
                                        });
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                                    control: control,
                                    name: "reportedInternally",
                                    render: (param)=>{
                                        let { field  } = param;
                                        var _errors_reportedInternally;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(radio_group, {
                                            options: [
                                                "Yes",
                                                "No"
                                            ],
                                            label: "Has the incident been reported to anyone in Distalmotion?",
                                            error: (_errors_reportedInternally = errors["reportedInternally"]) === null || _errors_reportedInternally === void 0 ? void 0 : _errors_reportedInternally.message,
                                            id: "reportedInternally",
                                            isDirty: dirtyFields["reportedInternally"],
                                            onChange: field.onChange,
                                            value: field.value
                                        });
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                                    control: control,
                                    name: "reportedExternally",
                                    render: (param)=>{
                                        let { field  } = param;
                                        var _errors_reportedExternally;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(radio_group, {
                                            options: [
                                                "Yes",
                                                "No"
                                            ],
                                            label: "Has the incident been reported to anyone outside of Distalmotion?",
                                            error: (_errors_reportedExternally = errors["reportedExternally"]) === null || _errors_reportedExternally === void 0 ? void 0 : _errors_reportedExternally.message,
                                            id: "reportedExternally",
                                            isDirty: dirtyFields["reportedExternally"],
                                            onChange: field.onChange,
                                            value: field.value
                                        });
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                                    control: control,
                                    name: "witnesses",
                                    render: (param)=>{
                                        let { field  } = param;
                                        var _errors_witnesses;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(radio_group, {
                                            options: [
                                                "Yes",
                                                "No"
                                            ],
                                            label: "Were there any witnesses?",
                                            error: (_errors_witnesses = errors["witnesses"]) === null || _errors_witnesses === void 0 ? void 0 : _errors_witnesses.message,
                                            id: "witnesses",
                                            isDirty: dirtyFields["witnesses"],
                                            onChange: field.onChange,
                                            value: field.value
                                        });
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_textarea/* default */.Z, {
                                    error: (_errors_namesOfWitnesses = errors["namesOfWitnesses"]) === null || _errors_namesOfWitnesses === void 0 ? void 0 : _errors_namesOfWitnesses.message,
                                    label: "If Yes, list the name(s) of the witnesses",
                                    id: "namesOfWitnesses",
                                    isDirty: dirtyFields["namesOfWitnesses"],
                                    ...register("namesOfWitnesses")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                                    control: control,
                                    name: "filesAvailable",
                                    render: (param)=>{
                                        let { field  } = param;
                                        var _errors_filesAvailable;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(radio_group, {
                                            options: [
                                                "Yes",
                                                "No"
                                            ],
                                            label: "Do you have files to support your report?",
                                            error: (_errors_filesAvailable = errors["filesAvailable"]) === null || _errors_filesAvailable === void 0 ? void 0 : _errors_filesAvailable.message,
                                            id: "filesAvailable",
                                            isDirty: dirtyFields["filesAvailable"],
                                            onChange: field.onChange,
                                            value: field.value
                                        });
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                                    name: "files",
                                    control: control,
                                    render: (param)=>/*#__PURE__*/ {
                                        let { field  } = param;
                                        return (0,jsx_runtime.jsxs)("div", {
                                            className: "relative group",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                    htmlFor: "files",
                                                    className: "block mb-2 text-15 leading-140 text-blue-800",
                                                    children: "If Yes, upload the document(s) you are willing to attach to your report"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex items-center space-x-2",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                            className: "text-11 text-blue-800 font-bold border border-blue px-4 py-2 rounded-xl flex-shrink-0 uppercase",
                                                            type: "button",
                                                            onClick: handleClick,
                                                            children: "Upload files"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "text-11",
                                                            children: Array.from((_field_value = field.value) !== null && _field_value !== void 0 ? _field_value : []).map((file)=>file.name).join(", ")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    id: "files",
                                                    type: "file",
                                                    multiple: true,
                                                    ref: fileInputRef,
                                                    onChange: (e)=>{
                                                        if (e.target.files) {
                                                            field.onChange(e.target.files);
                                                        }
                                                    },
                                                    style: {
                                                        display: "none"
                                                    }
                                                })
                                            ]
                                        });
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                                    control: control,
                                    name: "willingToAssist",
                                    render: (param)=>{
                                        let { field  } = param;
                                        var _errors_willingToAssist;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(radio_group, {
                                            options: [
                                                "Yes",
                                                "No"
                                            ],
                                            label: "Would you be willing to assist further if asked?",
                                            error: (_errors_willingToAssist = errors["willingToAssist"]) === null || _errors_willingToAssist === void 0 ? void 0 : _errors_willingToAssist.message,
                                            id: "willingToAssist",
                                            isDirty: dirtyFields["willingToAssist"],
                                            onChange: field.onChange,
                                            value: field.value
                                        });
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, {
                                            error: (_errors_email = errors["email"]) === null || _errors_email === void 0 ? void 0 : _errors_email.message,
                                            label: "If Yes, please provide your email address:",
                                            id: "email",
                                            isDirty: dirtyFields["email"],
                                            ...register("email"),
                                            type: "email"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-11",
                                            children: "By providing your email address, you enable Distalmotion to email you. Your email address will remain confidential as allowed by applicable law."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(submit_button/* default */.Z, {
                                    disabled: isSubmitting || submitState === "success",
                                    isSubmitting: isSubmitting,
                                    endMessage: "Report sent!",
                                    children: submitState === "success" ? "Report sent!" : (_settings_texts_valueContactSend = (_settings_texts = settings.texts) === null || _settings_texts === void 0 ? void 0 : _settings_texts.valueContactSend) !== null && _settings_texts_valueContactSend !== void 0 ? _settings_texts_valueContactSend : "Send Report"
                                })
                            ]
                        }),
                        submitState === "error" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-error col-start-2 col-span-10 md:col-start-4 md:col-span-6 space-y-2 text-15 [&>h1]:text-22 [&>h1]:font-bold [&>h2]:text-20 [&>h2]:font-bold [&>h3]:font-bold",
                            dangerouslySetInnerHTML: {
                                __html: errorMsg
                            }
                        }),
                        submitState === "success" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-start-2 col-span-10 md:col-start-4 md:col-span-6 space-y-2 text-15 [&>h1]:text-22 [&>h1]:font-bold [&>h2]:text-20 [&>h2]:font-bold [&>h3]:font-bold",
                                dangerouslySetInnerHTML: {
                                    __html: successMsg
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-start-2 col-span-10 md:col-start-4 md:col-span-6 space-y-2 text-15 [&>h1]:text-22 [&>h1]:font-bold [&>h2]:text-20 [&>h2]:font-bold [&>h3]:font-bold",
                    dangerouslySetInnerHTML: {
                        __html: notice
                    }
                })
            ]
        })
    });
}


/***/ }),

/***/ 4963:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Select; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8705);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7318);
/* harmony import */ var _heroicons_react_20_solid__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6032);
/* harmony import */ var _heroicons_react_20_solid__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4589);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);





function Select(param) {
    let { error , id , label , options , onChange , selected  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_3__/* .Listbox */ .R, {
        value: selected,
        onChange: onChange,
        children: (param)=>/*#__PURE__*/ {
            let { open  } = param;
            return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "relative group",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_3__/* .Listbox.Label */ .R.Label, {
                        htmlFor: id,
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("absolute -top-2.5 left-6 h-4 inline-block bg-white px-1 text-11 leading-140 font-bold z-10 uppercase", {
                            "text-blue-800": !error
                        }, {
                            "text-error": error
                        }),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "hidden group-focus-within:block absolute bottom-0 left-0 bg-iceblue-100 w-full h-1.5 z-0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "relative z-1",
                                children: label
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "relative",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_3__/* .Listbox.Button */ .R.Button, {
                                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("relative w-full cursor-default text-15 leading-140 tracking-3 focus:ring-1 outline-none border rounded-xl md:rounded-3xl px-7 py-4", {
                                    "border-blue-400 focus:bg-iceblue-100 focus:border-blue-400 focus:ring-blue-400 text-blue-800": !error
                                }, {
                                    "border-error focus:border-error focus:ring-error text-error": error
                                }),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "block text-left truncate",
                                        children: selected || "Please select an option"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-4",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_20_solid__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                            className: "h-5 w-5 text-gray-400",
                                            "aria-hidden": "true"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_5__/* .Transition */ .u, {
                                show: open,
                                as: react__WEBPACK_IMPORTED_MODULE_1__.Fragment,
                                leave: "transition ease-in duration-100",
                                leaveFrom: "opacity-100",
                                leaveTo: "opacity-0",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_3__/* .Listbox.Options */ .R.Options, {
                                    className: "absolute z-20 mt-1 max-h-60 w-full overflow-auto rounded-xl md:rounded-3xl bg-white py-1 text-base border border-blue-400 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm",
                                    children: options.map((option, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_3__/* .Listbox.Option */ .R.Option, {
                                            className: (param)=>{
                                                let { active  } = param;
                                                return classnames__WEBPACK_IMPORTED_MODULE_2___default()({
                                                    "bg-blue-500 text-white": active
                                                }, {
                                                    "text-gray-900": !active
                                                }, "relative cursor-default select-none py-2 pl-3 pr-9");
                                            },
                                            value: option,
                                            children: (param)=>/*#__PURE__*/ {
                                                let { selected , active  } = param;
                                                return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(selected ? "font-semibold" : "font-normal", "block truncate"),
                                                            children: option
                                                        }),
                                                        selected ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(active ? "text-white" : "text-blue-500", "absolute inset-y-0 right-0 flex items-center pr-4"),
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_20_solid__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                                className: "h-5 w-5",
                                                                "aria-hidden": "true"
                                                            })
                                                        }) : null
                                                    ]
                                                });
                                            }
                                        }, index))
                                })
                            })
                        ]
                    }),
                    error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "text-error text-11 px-7 pt-1 font-medium",
                        children: error
                    })
                ]
            });
        }
    });
}


/***/ }),

/***/ 809:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SubmitButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);



function SubmitButton(param) {
    let { children , className , isSubmitting , endMessage , ...props } = param;
    const [rect, setRect] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        width: null,
        height: null
    });
    const refButton = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    const refHiddenButton = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (!refHiddenButton.current) return;
        if (children === endMessage) {
            // width & height need to be calculated to animate the button,
            // because animating a width of 'auto' is not possible
            // https://css-tricks.com/using-css-transitions-auto-dimensions/
            const { width , height  } = refHiddenButton.current.getBoundingClientRect();
            setRect({
                width,
                height
            });
        }
    }, [
        children,
        endMessage
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (!refButton.current) return;
        const { width , height  } = refButton.current.getBoundingClientRect();
        setRect({
            width,
            height
        });
    }, [
        refButton
    ]);
    const { width , height  } = rect;
    const loadingCircleSize = width && height ? Math.min(width, height) : "auto";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                ref: refButton,
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(className, "relative text-blue-100 text-13 leading-140 tracking-8 bg-blue-400 hover:bg-blue-800 rounded-full font-bold uppercase px-5 flex justify-center items-center transition-[width, height] duration-500 py-2.5 focus:ring-blue-800 focus:bg-blue-800 focus:ring-1 outline-none", {
                    "outline-none": isSubmitting
                }),
                style: {
                    width: isSubmitting ? loadingCircleSize : width ? width : "auto",
                    height: isSubmitting ? loadingCircleSize : height ? height : "auto"
                },
                ...props,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("overflow-hidden flex ", {
                            "opacity-100 transition-opacity delay-500": !isSubmitting,
                            "opacity-0": isSubmitting
                        }),
                        children: children
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("absolute inset-0 transition-opacity rounded-full bg-white border-none", {
                            "opacity-0": !isSubmitting,
                            "opacity-100 scale-105 delay-500": isSubmitting
                        }),
                        children: [
                            -0.45,
                            -0.3,
                            -0.15,
                            0
                        ].map((delay, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("absolute rounded-full border-4 border-blue-500 border-r-transparent border-b-transparent border-l-transparent animate-loader w-10 h-10", {
                                    "opacity-0": !isSubmitting,
                                    "opacity-100": isSubmitting
                                }),
                                style: {
                                    animationDelay: "".concat(delay, "s")
                                }
                            }, index))
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                ref: refHiddenButton,
                "aria-hidden": "true",
                disabled: true,
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(className, "text-blue-100 text-13 leading-140 tracking-8 bg-blue-500 hover:bg-blue-800 rounded-full font-bold uppercase px-5 transition-[width, height] duration-500 py-2.5 invisible absolute -left-1000 top-0"),
                ...props,
                children: endMessage
            })
        ]
    });
}


/***/ }),

/***/ 5049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _heroicons_react_20_solid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4589);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);




const Textarea = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)((param, ref)=>{
    let { error , id , isDirty , label , className , ...textareaProps } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "relative group",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                htmlFor: id,
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("absolute -top-2.5 left-6 h-4 inline-block bg-white px-1 text-11 leading-140 font-bold uppercase", {
                    "text-blue-800": !error
                }, {
                    "text-error": error
                }),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "hidden group-focus-within:block absolute bottom-0 left-0 bg-iceblue-100 w-full h-1.5 z-0"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "relative z-1",
                        children: label
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("textarea", {
                id: id,
                ref: ref,
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("w-full text-15 leading-140 tracking-3 text-blue-800 border rounded-xl md:rounded-3xl pl-7 pr-16 py-4", {
                    "border-blue-400 focus:bg-iceblue-100 focus:border-blue-400 focus:ring-blue-400": !error
                }, {
                    "border-error focus:border-error focus:ring-error": error
                }, className),
                ...textareaProps
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_20_solid__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("absolute top-4 transition-opacity delay-300 right-6 w-6 h-6", {
                    "opacity-0": !isDirty || error
                }, {
                    "opacity-100": isDirty && !error
                })
            }),
            error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-error text-11 px-7 pt-1 font-medium",
                children: error
            })
        ]
    });
});
Textarea.displayName = "Textarea";
/* harmony default export */ __webpack_exports__["Z"] = (Textarea);


/***/ })

}]);